import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const ResultsIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      height={getDefaultHeight(svgProps, 24)}
      {...svgProps}
    >
      <g
        fill="none"
        stroke={color ?? "currentColor"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      >
        <path d="M2.25.75h19.5a1.538 1.538 0 011.5 1.5v19.5a1.538 1.538 0 01-1.5 1.5H2.25a1.538 1.538 0 01-1.5-1.5V2.15a1.52 1.52 0 011.5-1.4z" />
        <path d="M12.05 4.45l-4.5 6-3-3" />
        <path d="M14.25 8.15h4.6" />
        <path d="M12.05 13.45l-4.5 6-3-3" />
        <path d="M14.25 17.15h4.6" />
      </g>
    </SVG>
  );
};
